@if (loadingService.isLoading()) {
  <div class="loading-overlay">
    <app-skeleton-loading />
  </div>
}

@if (!loadingService.isLoading()) {
  <div class="layout-login">
    <div class="layout-login__left-side">
      <div class="layout-login__body">
        <div class="layout-login__login">
          <div class="layout-login__login-title">
            <span class="material-symbols-outlined layout-login__logo">local_shipping</span>
            <span class="layout-login__login-text">LRP Proveedores</span>
            <span class="layout-login__version">Beta</span>
          </div>
          <div class="layout-login__title">Ingresa a tu cuenta</div>
        </div>

        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
          <div class="base-form__form">
            <div class="base-form__fields">
              <div class="base-form__field">
                <app-input-field
                  inputControlName="username"
                  errorFieldName="Usuario"
                  [form]="loginForm"
                  labeltext="Usuario"
                  [required]="true"
                />
                @if (isUsernameNotEmpty()) {
                  <div class="base-form__field-icon" (click)="cleanField()">
                    <span class="material-symbols-outlined">close</span>
                  </div>
                }
              </div>

              <div class="base-form__field">
                <app-input-field
                  inputControlName="password"
                  errorFieldName="Contraseña"
                  [form]="loginForm"
                  labeltext="Contraseña"
                  [required]="true"
                  [type]="isPasswordVisible() ? 'text' : 'password'"
                />
                @if (isPasswordNotEmpty()) {
                  <div class="base-form__field-icon" (click)="togglePasswordVisibility()">
                    @if (isPasswordVisible()) {
                      <span class="material-symbols-outlined">visibility_off</span>
                    } @else {
                      <span class="material-symbols-outlined">visibility</span>
                    }
                  </div>
                }
                <span class="layout-login__forgot-password">¿Olvidaste la contraseña?</span>
              </div>

              @if (hasError()) {
                <div class="base-form__error-message">
                  Usuario o contraseña incorrectos
                </div>
              }
            </div>

            <div class="base-form__actions layout-login__form-btn">
              <button type="submit" class="btn-primary btn-modal">
                Iniciar sesión
              </button>
            </div>

            <div class="layout-login__footer">
              Al iniciar sesión aceptas los
              <a href="">Términos y condiciones</a> y autorizas el tratamiento
              de tus datos según nuestra
              <a href="">Política de privacidad</a>
            </div>
          </div>
        </form>
      </div>
    </div>

    <div class="layout-login__right-side">
      <div class="layout-login__banner-title">
        Gestiona tus documentos y pedidos de forma simple y eficiente.
      </div>
      <div class="layout-login__banner-subtitle">
        Todo en un <b>solo lugar.</b>
      </div>
      <div class="layout-login__banner-cover"></div>
    </div>
  </div>
}
